import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
const KIDS_REVIEW_NAMES = ['Isha Shah', 'Marquita Harris', 'Courtney Brown'];
export function KidsReviews() {
  const kidsReviews = STORM_REVIEWS.filter(r => KIDS_REVIEW_NAMES.includes(r.name));
  return <section className="py-24 bg-off-white" data-id="element-1999">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2000">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2001">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2002">
            Real Parents. Real Reviews.
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-2003">
            These reviews are from real Storm parents about their kids. No stock
            testimonials.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-2004">
          {kidsReviews.map(r => <ReviewCard key={r.name} quote={r.quote} name={r.name} label={r.label} data-id="element-2005" />)}
        </div>
      </div>
    </section>;
}